import { ILoadBoardPost } from 'types/loadBoardPosts'
import { generateApiActionTypes } from 'utils/actions/generateActionTypes'
import { ENDPOINTS } from 'utils/api/callApi'
import { keymirror } from 'utils/keymirror'

export interface IMarketplaceSettingsState {
  rate?: number
  marketOnMarketplace: boolean
  marketOnLoadBoards: boolean
}

export const LOAD_BOARD_POST_FETCH_ACTION_TYPES = generateApiActionTypes('LOAD_BOARD_POST_FETCH')
export const LOAD_BOARD_POST_COUNT_FETCH_ACTION_TYPES = generateApiActionTypes(
  'LOAD_BOARD_POST_COUNT_FETCH'
)
export const LOAD_BOARD_POST_EDIT_ACTION_TYPES = generateApiActionTypes('LOAD_BOARD_POST_EDIT')
export const MARKETPLACE_SETTINGS_EDIT_ACTION_TYPES = generateApiActionTypes(
  'MARKETPLACE_SETTINGS_EDIT'
)
export const LOAD_BOARD_POST_EDIT_MODAL = keymirror({
  LOAD_BOARD_POST_EDIT_MODAL_OPEN: undefined,
  LOAD_BOARD_POST_EDIT_MODAL_CLOSE: undefined,
})
export const MARKETPLACE_SETTINGS_EDIT_MODAL = keymirror({
  MARKETPLACE_SETTINGS_EDIT_MODAL_OPEN: undefined,
  MARKETPLACE_SETTINGS_EDIT_MODAL_CLOSE: undefined,
})

export const updateLoadBoardPost = (id: string, body: ILoadBoardPost[]) => {
  const requestData = {
    method: 'PUT',
    endpoint: ENDPOINTS.shipments,
    group: 'load_board_posts/update_all',
    id,
    body: {
      load_board_posts: body,
    },
  }
  return {
    type: undefined,
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(LOAD_BOARD_POST_EDIT_ACTION_TYPES),
    },
  }
}

export const getLoadBoardPosts = (id: string) => {
  const requestData = {
    method: 'GET',
    endpoint: ENDPOINTS.shipments,
    group: 'load_board_posts',
    params: { filters: { includes: ['similar_posts'] } },
    id,
  }
  return {
    type: undefined,
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(LOAD_BOARD_POST_FETCH_ACTION_TYPES),
    },
  }
}

export const getLoadBoardPostCounts = (id: string) => {
  const requestData = {
    method: 'GET',
    endpoint: ENDPOINTS.shipments,
    group: 'load_board_posts/count',
    id,
  }
  return {
    type: undefined,
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(LOAD_BOARD_POST_COUNT_FETCH_ACTION_TYPES),
    },
  }
}

export const openLoadBoardPostModal = () => ({
  type: LOAD_BOARD_POST_EDIT_MODAL.LOAD_BOARD_POST_EDIT_MODAL_OPEN,
})
export const closeLoadBoardPostModal = () => ({
  type: LOAD_BOARD_POST_EDIT_MODAL.LOAD_BOARD_POST_EDIT_MODAL_CLOSE,
})

export const updateMarketplaceSettings = (id: string, body: IMarketplaceSettingsState) => {
  const requestData = {
    method: 'PUT',
    endpoint: ENDPOINTS.shipments,
    group: 'marketplace_settings',
    id,
    body,
  }
  return {
    type: undefined,
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(MARKETPLACE_SETTINGS_EDIT_ACTION_TYPES),
    },
  }
}

export const openMarketplaceSettingsModal = () => ({
  type: MARKETPLACE_SETTINGS_EDIT_MODAL.MARKETPLACE_SETTINGS_EDIT_MODAL_OPEN,
})
export const closeMarketplaceSettingsModal = () => ({
  type: MARKETPLACE_SETTINGS_EDIT_MODAL.MARKETPLACE_SETTINGS_EDIT_MODAL_CLOSE,
})
